import React from "react";
import { WpMediaItem } from "codegen";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

interface ImageInterface {
  src: WpMediaItem | string;
  alt?: string;
  className?: string;
}

/**
 * Basic image component,
 *
 * @param src The source for the image, could be from GraphQL or JSON (for preview)
 * @param alt The alt text for the image
 * @param className - If a custom class is necessary
 * @returns a href component, will either scroll to id or gatsby navigate.
 *
 */

export const Image = ({ src, alt, className }: ImageInterface): JSX.Element => {
  if (src?.localFile) {
    return <GatsbyImage image={getImage(src.localFile)} alt={alt || ""} className={className} />;
  }

  // this will be used for the preview mostly
  if (src?.url) {
    return (
      <div className={`${className} gatsby-image-wrapper`}>
        <img src={src.url} alt={alt} />
      </div>
    );
  }

  return null;
};
